import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { getTradeDetails } from '../../services/PropertyDetailsAPI';
import { toastNotify } from '../../utils/toastNotify';

const initialState = {
  loading: false,
  data: {},
};

export const fetchTradeDetailsAction = createAsyncThunk('FETCH_TRADE_DETAILS', getTradeDetails);
export const tradeDetailsSlice = createSlice({
  name: 'tradeDetails',
  initialState,
  reducers: {
    updateTradeDetails: (state, action) => {
      state.data = { ...action.payload };
    },
  },
  extraReducers: {
    [fetchTradeDetailsAction.pending]: (state, action) => {
      return {
        ...state,
        loading: true,
      };
    },
    [fetchTradeDetailsAction.fulfilled]: (state, action) => {
      return {
        ...state,
        loading: false,
        data: action.payload,
      };
    },
    [fetchTradeDetailsAction.rejected]: (state, action) => {
      toastNotify('error', action.payload);
      return {
        ...state,
        loading: false,
        data: {},
      };
    },
  },
});

export const { updateTradeDetails } = tradeDetailsSlice.actions;
const { reducer } = tradeDetailsSlice;

export default reducer;
